import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { format, getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";

import { useStrings } from "../../localization/localizationHelpers";
import { CrmPitchConceptStatus } from "../../models/crmStatus";
import { PitchConceptData } from "../../models/forms";
import { RouteNames } from "../../partnerConfig/routeNames";
import { OnboardingUrls } from "../../partnerConfig/routes";

import { PitchConceptState } from "../../server/crm/api/models/forms";
import { FormPreview } from "./FormPreview";
import { FormPreviewValidDataType, ReadOnlyFormId } from "./ReadOnlyForms";

export type ApplicationInformationSectionProps = {
  pitchConceptInfo?: PitchConceptData & PitchConceptState;
};

export const PitchConceptFormPreview = ({
  pitchConceptInfo,
}: ApplicationInformationSectionProps) => {
  const [
    welcomePartnerPageApplicationName,
    welcomePartnerPagePitchStatusSubmitted,
    welcomePartnerPagePitchStatusReviewed,
    untitledGame,
  ] = useStrings(
    "welcomePartnerPageApplicationName",
    "welcomePartnerPagePitchStatusSubmitted",
    "welcomePartnerPagePitchStatusReviewed",
    "untitledGame"
  );
  const isSignedIn = useSelector(getIsUserSignedIn);
  const history = useHistory();

  useEffect(() => {
    if (!isSignedIn) {
      const navigateToPitchWelcomePage = () =>
        history.replace(OnboardingUrls[RouteNames.PitchWelcome]);
      navigateToPitchWelcomePage();
      return;
    }
  }, [isSignedIn, history]);

  if (!pitchConceptInfo) {
    return null;
  }
  const { publisherDeveloperInformation, aboutYourGame, askForXbox, aboutYourself, state } =
    pitchConceptInfo ?? {};

  const readOnlyForms = new Map<ReadOnlyFormId, FormPreviewValidDataType>([
    [ReadOnlyFormId.PitchPublisherDeveloperInformation, publisherDeveloperInformation],
    [ReadOnlyFormId.PitchAboutYourGame, aboutYourGame],
    [ReadOnlyFormId.PitchAskForXbox, askForXbox],
    [ReadOnlyFormId.PitchAboutYourself, aboutYourself],
  ]);

  let subtitle = "";
  switch (state?.status) {
    case CrmPitchConceptStatus.Submitted:
      subtitle = welcomePartnerPagePitchStatusSubmitted;
      break;
    case CrmPitchConceptStatus.Reviewed:
      subtitle = welcomePartnerPagePitchStatusReviewed;
      break;
  }

  return (
    <FormPreview
      title={format(welcomePartnerPageApplicationName, aboutYourGame?.gameTitle ?? untitledGame)}
      subtitle={subtitle}
      readOnlyForms={readOnlyForms}
    />
  );
};
